// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.final-four-container {
  width: 100%;
  overflow-x: auto;
  scroll-behavior: smooth;
}
.final-four-container * {
  transition: height 0.3s ease;
}

.final-four {
  display: flex;
  align-items: flex-start;
  gap: 20px;
}
.final-four .final-four-column {
  margin-right: 25px;
}
.final-four .final-four-column .final-four-game {
  margin-bottom: 30px;
}
.final-four .final-four-column .final-four-game:last-child {
  margin-bottom: 0;
}
.final-four .final-four-column.final-four-column-games-second .MuiBox-root, .final-four .final-four-column.final-four-column-games-third .MuiBox-root, .final-four .final-four-column.final-four-column-games-final .MuiBox-root {
  transition: height 0.3s ease, padding-bottom 0.3s ease;
}
.final-four .final-four-connector-column {
  width: 0px;
  display: flex;
  flex-direction: column;
  margin-top: 136px;
  transition: all 0.3s ease;
}
.final-four .final-four-connector-column .connector-wrapper {
  position: relative;
  transition: height 0.3s ease, margin-bottom 0.3s ease;
}
.final-four .final-four-connector-column .connector-wrapper .vertical-line {
  position: absolute;
  left: 50%;
  width: 2px;
  background-color: black;
  margin-left: 14px;
  transition: height 0.3s ease, top 0.3s ease;
}
.final-four .final-four-connector-column.first-round .connector {
  position: relative;
  height: 150px;
  width: 30px;
}
.final-four .final-four-connector-column.first-round .connector::after {
  content: "";
  position: absolute;
  left: 50%;
  top: 65px;
  height: 210px;
  width: 2px;
  background-color: #000;
  transform: translateX(-50%);
}
.final-four .first-round-expanded {
  height: 260px;
  margin-bottom: 60px;
}
.final-four .first-round-expanded .vertical-line {
  top: 65px;
  height: 162px;
}
.final-four .first-round-compressed {
  height: 130px;
  margin-bottom: 30px;
}
.final-four .first-round-compressed .vertical-line {
  top: 45px;
  height: 81px;
}
.final-four .second-round-expanded {
  height: 520px;
  margin-bottom: 120px;
}
.final-four .second-round-expanded .vertical-line {
  top: 149.5px;
  height: 322px;
}
.final-four .second-round-compressed {
  height: 260px;
  margin-bottom: 236px;
}
.final-four .second-round-compressed .vertical-line {
  top: 149.5px;
  height: 250px;
}
.final-four .sweet-16-expanded {
  height: 520px;
}
.final-four .sweet-16-expanded .vertical-line {
  top: 309px;
  height: 641.5px;
}
.final-four .sweet-16-compressed {
  height: 260px;
}
.final-four .sweet-16-compressed .vertical-line {
  top: 273.5px;
  height: 498px;
}

.active-round-2 .final-four-column-games-second .final-four-game + .MuiBox-root {
  height: 80px !important;
}

.active-round-3 .final-four-column-games-third .final-four-game + .MuiBox-root {
  height: 240px !important;
}

.active-round-4 .final-four-column-games-final .MuiBox-root {
  padding-bottom: 296px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Brackets/SixteenTeamBracket/FourTeamBracketDesktop.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,gBAAA;EACA,uBAAA;AACJ;AACI;EACI,4BAAA;AACR;;AAGA;EACI,aAAA;EACA,uBAAA;EACA,SAAA;AAAJ;AAEI;EACI,kBAAA;AAAR;AAEQ;EACI,mBAAA;AAAZ;AAEY;EACI,gBAAA;AAAhB;AAOY;EACI,sDAAA;AALhB;AAWI;EACI,UAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,yBAAA;AATR;AAWQ;EACI,kBAAA;EACA,qDAAA;AATZ;AAWY;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;EACA,iBAAA;EACA,2CAAA;AAThB;AAeY;EACI,kBAAA;EACA,aAAA;EACA,WAAA;AAbhB;AAegB;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,aAAA;EACA,UAAA;EACA,sBAAA;EACA,2BAAA;AAbpB;AAoBI;EACI,aAAA;EACA,mBAAA;AAlBR;AAoBQ;EACI,SAAA;EACA,aAAA;AAlBZ;AAsBI;EACI,aAAA;EACA,mBAAA;AApBR;AAsBQ;EACI,SAAA;EACA,YAAA;AApBZ;AAyBI;EACI,aAAA;EACA,oBAAA;AAvBR;AAyBQ;EACI,YAAA;EACA,aAAA;AAvBZ;AA2BI;EACI,aAAA;EACA,oBAAA;AAzBR;AA2BQ;EACI,YAAA;EACA,aAAA;AAzBZ;AA8BI;EACI,aAAA;AA5BR;AA8BQ;EACI,UAAA;EACA,eAAA;AA5BZ;AAgCI;EACI,aAAA;AA9BR;AAgCQ;EACI,YAAA;EACA,aAAA;AA9BZ;;AAsCQ;EACI,uBAAA;AAnCZ;;AA0CQ;EACI,wBAAA;AAvCZ;;AA8CQ;EACI,gCAAA;AA3CZ","sourcesContent":[".final-four-container {\n    width: 100%;\n    overflow-x: auto;\n    scroll-behavior: smooth;\n\n    * {\n        transition: height 0.3s ease;\n    }\n}\n\n.final-four {\n    display: flex;\n    align-items: flex-start;\n    gap: 20px;\n  \n    .final-four-column {\n        margin-right: 25px;\n      \n        .final-four-game {\n            margin-bottom: 30px;\n            \n            &:last-child {\n                margin-bottom: 0;\n            }\n        }\n\n        &.final-four-column-games-second,\n        &.final-four-column-games-third,\n        &.final-four-column-games-final {\n            .MuiBox-root {\n                transition: height 0.3s ease, padding-bottom 0.3s ease;\n            }\n        }\n    }\n  \n    // Base connector column styles\n    .final-four-connector-column {\n        width: 0px;\n        display: flex;\n        flex-direction: column;\n        margin-top: 136px;\n        transition: all 0.3s ease;\n  \n        .connector-wrapper {\n            position: relative;\n            transition: height 0.3s ease, margin-bottom 0.3s ease;\n            \n            .vertical-line {\n                position: absolute;\n                left: 50%;\n                width: 2px;\n                background-color: black;\n                margin-left: 14px;\n                transition: height 0.3s ease, top 0.3s ease;\n            }\n        }\n\n        // New Final Four connector styles\n        &.first-round {\n            .connector {\n                position: relative;\n                height: 150px;\n                width: 30px;\n                \n                &::after {\n                    content: '';\n                    position: absolute;\n                    left: 50%;\n                    top: 65px;\n                    height: 210px;\n                    width: 2px;\n                    background-color: #000;\n                    transform: translateX(-50%);\n                }\n            }\n        }\n    }\n\n    // First round specific styles\n    .first-round-expanded {\n        height: 260px;\n        margin-bottom: 60px;\n\n        .vertical-line {\n            top: 65px;\n            height: 162px;\n        }\n    }\n\n    .first-round-compressed {\n        height: 130px;\n        margin-bottom: 30px;\n\n        .vertical-line {\n            top: 45px;\n            height: 81px;\n        }\n    }\n\n    // Second round specific styles\n    .second-round-expanded {\n        height: 520px;\n        margin-bottom: 120px;\n\n        .vertical-line {\n            top: 149.5px;\n            height: 322px;\n        }\n    }\n\n    .second-round-compressed {\n        height: 260px;\n        margin-bottom: 236px;\n\n        .vertical-line {\n            top: 149.5px;\n            height: 250px;\n        }\n    }\n\n    // Sweet 16 specific styles\n    .sweet-16-expanded {\n        height: 520px;\n\n        .vertical-line {\n            top: 309px;\n            height: 641.5px;\n        }\n    }\n\n    .sweet-16-compressed {\n        height: 260px;\n\n        .vertical-line {\n            top: 273.5px;\n            height: 498px;\n        }\n    }\n}\n\n// Active round styles\n.active-round-2 {\n    .final-four-column-games-second {\n        .final-four-game + .MuiBox-root {\n            height: 80px !important;\n        }\n    }\n}\n\n.active-round-3 {\n    .final-four-column-games-third {\n        .final-four-game + .MuiBox-root {\n            height: 240px !important;\n        }\n    }\n}\n\n.active-round-4 {\n    .final-four-column-games-final {\n        .MuiBox-root {\n            padding-bottom: 296px !important;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
